import isEmpty from 'lodash/isEmpty';

import { getOauthPartnerId } from '../../components/auth/oauthProvider/getPartnerParams';
import findPartnerInfo from '../../utils/findPartnerInfo';
import { fetchPartnersEffect } from '../../actions/partners';
import { selectPartners } from '../../selectors/partners';

export default function fetchPartner({ location }) {
  return (dispatch, getState) => {
    const id = getOauthPartnerId(location);
    const partners = selectPartners(getState());
    const partnerInfo = findPartnerInfo(location, partners);

    if (id && isEmpty(partnerInfo)) {
      return dispatch(fetchPartnersEffect(id));
    }

    return null;
  };
}
